import { Outlet } from 'react-router-dom';

import { DashboardStatsProvider } from '@features/ownedParkingManage/contexts/DashboardStatsContext';

export default function DashboardDataLayout() {
  return (
    <DashboardStatsProvider>
      <Outlet />
    </DashboardStatsProvider>
  );
}
